// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDataPieChart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.657 6.331A8 8 0 0 0 14 4.242v5.746h5.746a7.998 7.998 0 0 0-2.09-3.657zM12.5 11.988a.5.5 0 0 1-.5-.5v-9c0-.276.224-.501.5-.487a10 10 0 0 1 9.488 9.487.481.481 0 0 1-.488.5zm-3.096-9.66A.478.478 0 0 1 10 2.8v1.053a.522.522 0 0 1-.373.493A8 8 0 1 0 19.642 14.36a.522.522 0 0 1 .494-.373h1.052c.316 0 .554.29.472.596-1.143 4.264-5.035 7.404-9.66 7.404-5.523 0-10-4.477-10-10 0-4.625 3.14-8.517 7.404-9.66z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDataPieChart;
